import type { ImageGenModelCatalogEntry } from '@glyphic/shared-core'

import type { ClientUiPublic } from '../../api/platformConfig'
import { normalizeCatalogPlatformId } from '../../constants/aiPlatforms'
import { effectiveImageSizes } from '../clientUiImageModel'
import { comicReferenceCapableModels } from '../comicReferenceModels'

/** ClientUi → shared-core Guard 用的模型目录 */
export function toImageGenModelCatalog(clientUi: ClientUiPublic): ImageGenModelCatalogEntry[] {
  return clientUi.imageModels.map((m) => ({
    platform: normalizeCatalogPlatformId(m.platform) ?? m.platform ?? '',
    id: m.id,
    supportsReferenceImages: m.supportsReferenceImages,
  }))
}

export function toReferenceCapableCatalog(clientUi: ClientUiPublic): ImageGenModelCatalogEntry[] {
  return comicReferenceCapableModels(clientUi).map((m) => ({
    platform: normalizeCatalogPlatformId(m.platform) ?? m.platform ?? '',
    id: m.id,
    supportsReferenceImages: true,
  }))
}

export function allowedApiSizesForModel(
  clientUi: ClientUiPublic,
  platformId: string,
  modelId: string,
): string[] {
  return effectiveImageSizes(clientUi, modelId, platformId).map((o) => o.value)
}
